import React from "react";
import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function VideowithBgPreview({ preview }) {
  const bgImage = {
    backgroundImage: "url(" + preview.img_urls + ")"
  };
  return (
    <div>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-video-with-bg" style={bgImage}>
          {/* {preview.img_urls && <img src={preview.img_urls} alt="" />} */}
          {preview.video_urls && <video controls src={preview.video_urls} />}
        </div>
      </div>
    </div>
  );
}

export default VideowithBgPreview;
